export function getQValueAccountId() {
    try {
        const user = JSON.parse(localStorage.getItem('user'));
        return user && user.accountId != null ? user.accountId : null;
    } catch (e) {
        return null;
    }
}
